export class SellerPerformanceTemplateConstants {
}
// Common output column names
SellerPerformanceTemplateConstants.SegmentSummarySegment = 'Segment';
SellerPerformanceTemplateConstants.SegmentSummarySegmentNumeric = 'SegmentNumeric';
SellerPerformanceTemplateConstants.SegmentSummaryCount = 'Count';
// Radar
SellerPerformanceTemplateConstants.RadarSegment = 'Segment';
SellerPerformanceTemplateConstants.RadarCount = 'Count';
SellerPerformanceTemplateConstants.RadarAttainmentAverage = 'AttainmentAVG';
SellerPerformanceTemplateConstants.RadarAttainmentScaled = 'AttainmentScaled';
SellerPerformanceTemplateConstants.RadarAvgDealSizeAverage = 'AvgDealSizeAVG';
SellerPerformanceTemplateConstants.RadarAvgDealSizeScaled = 'AvgDealSizeScaled';
SellerPerformanceTemplateConstants.RadarWinRateAverage = 'WinRateAVG';
SellerPerformanceTemplateConstants.RadarWinRateScaled = 'WinRateScaled';
SellerPerformanceTemplateConstants.RadarRevenueAverage = 'RevenueAVG';
SellerPerformanceTemplateConstants.RadarRevenueScaled = 'RevenueScaled';
SellerPerformanceTemplateConstants.RadarVariablePayRatioAverage = 'VariablePayRatioAVG';
SellerPerformanceTemplateConstants.RadarVariablePayRatioScaled = 'VariablePayRatioScaled';
// Segmentation
SellerPerformanceTemplateConstants.SegmentationSegment = 'Name';
SellerPerformanceTemplateConstants.SegmentationSegmentNumeric = 'Prediction';
SellerPerformanceTemplateConstants.SegmentationProbability = 'Probability';
SellerPerformanceTemplateConstants.SegmentationColumn = 'Column';
SellerPerformanceTemplateConstants.SegmentationOperator = 'Operator';
SellerPerformanceTemplateConstants.SegmentationValue = 'Value';
// Seller Data
SellerPerformanceTemplateConstants.SellerDataOutput = 'Seller Data';
SellerPerformanceTemplateConstants.SellerDataMediansOutput = 'Seller Data Medians';
SellerPerformanceTemplateConstants.MadeQuotaSummary = 'Made Quota Summary';
// Blended
SellerPerformanceTemplateConstants.BlendedPredictionsOutput = 'Blended Predictions';
SellerPerformanceTemplateConstants.BlendedSegmentationSummaryOutput = 'Blended Segment Summary';
SellerPerformanceTemplateConstants.BlendedRadarOutput = 'Blended Radar';
SellerPerformanceTemplateConstants.BlendedSegmentationOutput = 'Blended Segmentation';
// Attainment
SellerPerformanceTemplateConstants.AttainmentPredictionsOutput = 'Attainment Predictions';
SellerPerformanceTemplateConstants.AttainmentSegmentationSummaryOutput = 'Attainment Segment Summary';
SellerPerformanceTemplateConstants.AttainmentRadarOutput = 'Attainment Radar';
SellerPerformanceTemplateConstants.AttainmentSegmentationOutput = 'Attainment Segmentation';
// Average Deal Size
SellerPerformanceTemplateConstants.AvgDealSizePredictionsOutput = 'AvgDealSize Predictions';
SellerPerformanceTemplateConstants.AvgDealSizeSegmentationSummaryOutput = 'AvgDealSize Segment Summary';
SellerPerformanceTemplateConstants.AvgDealSizeRadarOutput = 'AvgDealSize Radar';
SellerPerformanceTemplateConstants.AvgDealSizeSegmentationOutput = 'AvgDealSize Segmentation';
// Win Rate
SellerPerformanceTemplateConstants.WinRatePredictionsOutput = 'WinRate Predictions';
SellerPerformanceTemplateConstants.WinRateSegmentationSummaryOutput = 'WinRate Segment Summary';
SellerPerformanceTemplateConstants.WinRateRadarOutput = 'WinRate Radar';
SellerPerformanceTemplateConstants.WinRateSegmentationOutput = 'WinRate Segmentation';
// Revenue
SellerPerformanceTemplateConstants.RevenuePredictionsOutput = 'Revenue Predictions';
SellerPerformanceTemplateConstants.RevenueSegmentationSummaryOutput = 'Revenue Segment Summary';
SellerPerformanceTemplateConstants.RevenueRadarOutput = 'Revenue Radar';
SellerPerformanceTemplateConstants.RevenueSegmentationOutput = 'Revenue Segmentation';
// Variable Pay Ratio
SellerPerformanceTemplateConstants.VariablePayRatioPredictionsOutput = 'VariablePayRatio Predictions';
SellerPerformanceTemplateConstants.VariablePayRatioSegmentationSummaryOutput = 'VariablePayRatio Segment Summary';
SellerPerformanceTemplateConstants.VariablePayRatioRadarOutput = 'VariablePayRatio Radar';
SellerPerformanceTemplateConstants.VariablePayRatioSegmentationOutput = 'VariablePayRatio Segmentation';
// Histograms
SellerPerformanceTemplateConstants.AttainmentHistogramOutput = 'Attainment Histogram';
SellerPerformanceTemplateConstants.AvgDealSizeHistogramOutput = 'AvgDealSize Histogram';
SellerPerformanceTemplateConstants.WinRateHistogramOutput = 'WinRate Histogram';
SellerPerformanceTemplateConstants.RevenueHistogramOutput = 'Revenue Histogram';
SellerPerformanceTemplateConstants.VariablePayRatioHistogramOutput = 'VariablePayRatio Histogram';
SellerPerformanceTemplateConstants.BlendedHistogramOutput = 'Blended Histogram';
SellerPerformanceTemplateConstants.HistogramBin = 'Bin';
SellerPerformanceTemplateConstants.HistogramCount = 'Count';
// Keep IDs
SellerPerformanceTemplateConstants.SellerPerformanceDataElementID = 'isrsjQtkyimIYw';
SellerPerformanceTemplateConstants.RenameSellerColumnsElementID = 'mSwayonHm5B3TQ';
SellerPerformanceTemplateConstants.DropForBlendedRegressorElementID = 'dBuR5mm8nW2lUw';
SellerPerformanceTemplateConstants.DropForAttainmentRegressorElementID = 'WK040dlLHBPG4w';
SellerPerformanceTemplateConstants.DropForAvgDealSizeRegressorElementID = 'tzofL3gNuTWXzQ';
SellerPerformanceTemplateConstants.DropForWinRateRegressorElementID = '9ViseCsi3AWeXw';
SellerPerformanceTemplateConstants.DropForRevenueRegressorElementID = '2wLKsba-WBTMEA';
SellerPerformanceTemplateConstants.DropForVariablePayRatioRegressorElementID = 'mRehTJ_digye_Q';
SellerPerformanceTemplateConstants.BlendedRegressorElementID = 'ZdVypCKfbu7TGA';
SellerPerformanceTemplateConstants.AttainmentRegressorElementID = 'kdH6qanbAwwOhg';
SellerPerformanceTemplateConstants.AvgDealSizeRegressorElementID = 'RXicZNriwZJf4g';
SellerPerformanceTemplateConstants.WinRateRegressorElementID = 'Z1O_SHTdij87aA';
SellerPerformanceTemplateConstants.RevenueRegressorElementID = 'SEG7pPBI7bSjDA';
SellerPerformanceTemplateConstants.VariablePayRatioRegressorElementID = '7nl9N-ywZGJ4Wg';
// Other IDs
SellerPerformanceTemplateConstants.VariablePayRatioSegmentation = 'qEiY_oIMe-aKCw';
SellerPerformanceTemplateConstants.VariablePayRatioRegressor = '7nl9N-ywZGJ4Wg';
SellerPerformanceTemplateConstants.VariablePayRatioBinningForHistogram = 'JCuJPnEpE52Dsg';
SellerPerformanceTemplateConstants.WinRateSegmentation = 'lLKNrOBfmfiYig';
SellerPerformanceTemplateConstants.WinRateRegressor = 'Z1O_SHTdij87aA';
SellerPerformanceTemplateConstants.WinRateBinningForHistogram = 'bA74Wv1nhQrjiA';
SellerPerformanceTemplateConstants.BlendedFormula = 'UXfUZtFRP3vgTw';
SellerPerformanceTemplateConstants.ReservedColumnNames = [
    SellerPerformanceTemplateConstants.SegmentSummarySegmentNumeric,
    SellerPerformanceTemplateConstants.SegmentSummaryCount,
    SellerPerformanceTemplateConstants.RadarSegment,
    SellerPerformanceTemplateConstants.RadarCount,
    SellerPerformanceTemplateConstants.RadarAttainmentAverage,
    SellerPerformanceTemplateConstants.RadarAttainmentScaled,
    SellerPerformanceTemplateConstants.RadarAvgDealSizeAverage,
    SellerPerformanceTemplateConstants.RadarAvgDealSizeScaled,
    SellerPerformanceTemplateConstants.RadarWinRateAverage,
    SellerPerformanceTemplateConstants.RadarWinRateScaled,
    SellerPerformanceTemplateConstants.RadarRevenueAverage,
    SellerPerformanceTemplateConstants.RadarRevenueScaled,
    SellerPerformanceTemplateConstants.RadarVariablePayRatioAverage,
    SellerPerformanceTemplateConstants.RadarVariablePayRatioScaled,
    SellerPerformanceTemplateConstants.SegmentationSegment,
    SellerPerformanceTemplateConstants.SegmentationSegmentNumeric,
    SellerPerformanceTemplateConstants.SegmentationProbability,
    SellerPerformanceTemplateConstants.SegmentationColumn,
    SellerPerformanceTemplateConstants.SegmentationOperator,
    SellerPerformanceTemplateConstants.SegmentationValue,
    SellerPerformanceTemplateConstants.MadeQuotaSummary,
    SellerPerformanceTemplateConstants.HistogramBin,
    SellerPerformanceTemplateConstants.HistogramCount
];
//# sourceMappingURL=sellerPerformanceTemplateConstants.js.map